import React from 'react';
import './ArticleComponentCSS/Paragraph.css';

const Paragraph = ({ text }) => {
  return <p className="paragraph">{text}</p>;
};

export default Paragraph;
